// src/pages/Contact.js (GÜNCEL)
import React, { useMemo, useState } from "react";
import SITE from "../data/site.json";

const INIT = { name: "", email: "", subject: "", message: "", phone: "", website: "" };

function validate(values) {
  const errors = {};
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  if (!values.name || values.name.trim().length < 2) errors.name = "Lütfen adınızı girin (min 2 karakter).";
  if (!values.email || !emailRe.test(values.email)) errors.email = "Geçerli bir e-posta adresi girin.";
  if (!values.message || values.message.trim().length < 10) errors.message = "Mesaj en az 10 karakter olmalıdır.";
  if (values.website) errors.website = "Spam tespit edildi.";
  return errors;
}

/** "05327700295" -> "tel:+905327700295" (varsayılan ülke: TR) */
function formatTelHref(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "";
  // Başında 0 varsa yerel format kabul edelim: 0 532 ... -> +90 532 ...
  if (digits.length === 11 && digits.startsWith("0")) {
    return `+90${digits.slice(1)}`;
  }
  // 90 ile başlıyorsa zaten ülke kodlu olabilir
  if (digits.length === 12 && digits.startsWith("90")) {
    return `+${digits}`;
  }
  // 10 hane (532...) geldiyse TR varsayalım
  if (digits.length === 10) {
    return `+90${digits}`;
  }
  // Diğer durumlar: + ekle
  return `+${digits}`;
}

/** "05327700295" -> "0 (532) 770 02 95" veya ülke kodluysa "+90 (532) 770 02 95" */
function formatTelHuman(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return raw;

  let cc = ""; // +90 veya boş
  let local = digits;

  if (digits.startsWith("90") && digits.length === 12) {
    cc = "+90";
    local = digits.slice(2);
  } else if (digits.startsWith("0") && digits.length === 11) {
    cc = "0";
    local = digits.slice(1);
  } else if (digits.length === 10) {
    cc = "+90";
  }

  if (local.length === 10) {
    const a = local.slice(0, 3);  // 532
    const b = local.slice(3, 6);  // 770
    const c = local.slice(6, 8);  // 02
    const d = local.slice(8, 10); // 95
    if (cc === "0") return `0 (${a}) ${b} ${c} ${d}`;
    if (cc === "+90") return `+90 (${a}) ${b} ${c} ${d}`;
  }

  // Fallback (biçilim dışıysa)
  return raw;
}

export default function Contact() {
  const [values, setValues] = useState(INIT);
  const [touched, setTouched] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const errors = useMemo(() => validate(values), [values]);
  const isValid = Object.keys(errors).length === 0;

  const onChange = (e) => setValues((v) => ({ ...v, [e.target.name]: e.target.value }));
  const onBlur = (e) => setTouched((t) => ({ ...t, [e.target.name]: true }));

  async function onSubmit(e) {
    e.preventDefault();
    setTouched({ name: true, email: true, message: true });
    if (!isValid) return;
    try {
      setSubmitting(true);
      // TODO: Buraya gerçek submit (fetch/axios) eklenebilir
      setResult({ ok: true, msg: "Form başarıyla gönderildi. En kısa sürede dönüş yapacağız." });
      setValues(INIT); setTouched({});
    } catch {
      setResult({ ok: false, msg: "Bir hata oluştu, lütfen tekrar deneyin." });
    } finally { setSubmitting(false); }
  }

  // Telefonları topla (geri uyumluluk: SITE.phone hâlâ varsa onu da ekler)
  const phoneItems = Array.isArray(SITE.phones) && SITE.phones.length > 0
    ? SITE.phones
    : (SITE.phone ? [{ label: "Telefon", number: SITE.phone }] : []);

  return (
    <section className="section">
      <div className="container">
        <header className="section-head">
          <h1 className="page-title">İletişim</h1>
          <p className="page-subtitle">Adres, iletişim bilgileri ve teklif formu.</p>
        </header>

        <div className="contact-top">
          <div className="contact-card">
            <h3 className="contact-title">{SITE.companyName}</h3>
            <ul className="contact-list">
              <li><strong>Adres:</strong> {SITE.address}</li>

              {/* Birden fazla telefon satırı */}
              {phoneItems.map((p, idx) => {
                const href = `tel:${formatTelHref(p.number)}`;
                const human = formatTelHuman(p.number);
                return (
                  <li key={idx}>
                    <strong>{p.label}:</strong>{" "}
                    <a href={href} aria-label={`${p.label} telefon ara`}>
                      {human}
                    </a>
                  </li>
                );
              })}

              <li>
                <strong>E-posta:</strong>{" "}
                <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
              </li>
              <li><strong>Çalışma Saatleri:</strong> {SITE.workHours}</li>
            </ul>
          </div>

          <div className="map-card" aria-label="Harita">
            <iframe
              title={`Konum: ${SITE.address}`}
              src={`https://www.google.com/maps?q=${encodeURIComponent(SITE.address)}&output=embed`}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen=""
            />
          </div>
        </div>
      </div>
    </section>
  );
}